import React, { Fragment } from "react";

export const Placeholder: React.FC<any> = ({ children }) => {
    return (
        <Fragment>
            {children}
        </Fragment>
    );
};